import { render, staticRenderFns } from "./MultimediaModal.vue?vue&type=template&id=c6ff6922&scoped=true"
import script from "./MultimediaModal.vue?vue&type=script&lang=js"
export * from "./MultimediaModal.vue?vue&type=script&lang=js"
import style0 from "./MultimediaModal.vue?vue&type=style&index=0&id=c6ff6922&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ff6922",
  null
  
)

export default component.exports